import "preact/debug";
import { h, Component, Fragment, createRef } from "preact";
import PropTypes from "prop-types";
import { sendRequest, validateFiles, validateEmail } from "../../tools";
import SelectInput from "./SelectInput";
import FileInput from "./FileInput";
import Modal from "./Modal";
import CameraButton from "./CameraButton";
import { allowedFileTypes, maxCountFile, maxSizeFile } from "../../helper";
import AutoAnswer from "./AutoAnswer";
import QualityForm from "./QualityForm";

export default class AppealForm extends Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
    urlToDetail: PropTypes.string.isRequired,
    contracts: PropTypes.array.isRequired,
    subjects: PropTypes.array.isRequired,
    subjectsCut: PropTypes.array.isRequired,
    onSubmited: PropTypes.func,
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.phoneInputRef = createRef();

    this.state = {
      values: {
        subjects: [],
        files: [],
        subtopics: [],
        subtopic: undefined,
      },
      modalCamera: false,
      loading: false,
      error: [],
      answers: [],
      showForm: false,
      loadingAnswer: false,
      advFields: {},
      advFieldsNames: {},
    };
    this.submitted = false;
    this.requiredFields = [
      "subject",
      "subtopic",
      "message",
      "email",
      "phone",
      "name",
    ];
    this.fieldsName = {
      subject: "Тема вопроса",
      subtopic: "Подтема",
      message: "Вопрос",
      phone: "Мобильный телефон",
      email: "E-mail",
      name: "Обращение",
    };
  }

  clearForm = () => {
    this.submitted = false;
    const contract = this.props.contracts[0];
    let subjects = this.props.subjects;
    if (typeof contract === "undefined" || !contract.contractGlobalId) {
      subjects = this.props.subjectsCut;
    }

    $(this.phoneInputRef.current).val(this.props.phone);

    this.setState({
      modalCamera: false,
      values: {
        subject: undefined,
        message: "",
        name: this.props.name,
        phone: this.props.phone,
        email: this.props.email,
        files: [],
        contractGlobalId:
          typeof contract !== "undefined" ? contract.contractGlobalId : "",
        subjects: subjects,
        subtopics: [],
        subtopic: undefined,
      },
      answers: [],
      showForm: false,
      loadingAnswer: false,
      advFields: {},
      advFieldsNames: {},
    });
  };

  componentDidMount() {
    this.clearForm();
  }

  componentDidUpdate() {
    if (this.phoneInputRef.current) {
      const self = this;
      $(this.phoneInputRef.current)
        .inputmask({
          mask: "+7 (999) 999 9999",
          clearIncomplete: true,
          oncomplete: function (e) {
            self.setValues({ phone: e.target.value });
          },
          onincomplete: function () {
            self.setValues({ phone: "" });
          },
        })
        .val(this.state.values.phone);
    }
  }

  render(props, state, context) {
    const errors = this.validate();
    const errorsAdvFields = this.validateAdvFields();

    return (
      <form className="form-block main__full-wd-xs">
        <div className="form-block__header">
          <h2 className="form-block__title">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 18H13V16H11V18ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C9.79 6 8 7.79 8 10H10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 12 11 11.75 11 15H13C13 12.75 16 12.5 16 10C16 7.79 14.21 6 12 6Z"
                fill="black"
              />
            </svg>
            Здесь Вы можете задать вопрос
          </h2>
        </div>
        <div className="form-block__section">
          <fieldset className="form-field form-field_dir-min-md_row form-block__item form-block__item_mgt_xs">
            <div className="form-field__inner">
              <div className="form-field__title-row">
                <legend className="form-field__title">Адрес</legend>
              </div>
              <div
                className={`form-field__input-row form-field__input-row_min-ht_none ${
                  errors.contractGlobalId ? "form-field_state_error" : ""
                }`}
              >
                <SelectInput
                  onChange={this.onChangeAddress}
                  placeholder="Без адреса"
                  getItemName={(item) => item.address}
                  getItemValue={(item) => item.contractGlobalId}
                  items={this.props.contracts}
                  checkedItem={
                    state.values.contractGlobalId
                  } /*checkedItem={state.values.contractGlobalId}*/ /* WTF checkedItem={state.values.address} */
                  isCheckedValue={(item) =>
                    item.contractGlobalId === state.values.contractGlobalId
                  }
                />
              </div>
            </div>
          </fieldset>
          <fieldset className="form-field form-field_dir-min-md_row form-block__item form-block__item_mgt_xs">
            <div className="form-field__inner">
              <div className="form-field__title-row">
                <legend className="form-field__title">Тема вопроса *</legend>
              </div>
              <div
                className={`form-field__input-row form-field__input-row_min-ht_none ${
                  errors.subject ? "form-field_state_error" : ""
                }`}
              >
                <SelectInput
                  onChange={this.onChangeSubject}
                  placeholder="Выберите тему"
                  getItemName={(item) => item.title}
                  getItemValue={(item) => item.id}
                  items={state.values.subjects}
                  checkedItem={state.values.subject}
                  isCheckedValue={(item) => item.id === state.values.subject}
                />
              </div>
            </div>
          </fieldset>
          <fieldset
            className={`form-field form-field_dir-min-md_row form-block__item form-block__item_mgt_xs ${
              this.state.values.subtopics.length === 0
                ? "form-field_state_disabled"
                : ""
            }`}
          >
            <div className="form-field__inner">
              <div className="form-field__title-row">
                <legend className="form-field__title">Подтема *</legend>
              </div>
              <div
                className={`form-field__input-row form-field__input-row_min-ht_none ${
                  errors.subtopic ? "form-field_state_error" : ""
                }`}
              >
                <SelectInput
                  onChange={this.onChangeSubtopic}
                  placeholder="Выберите подтему"
                  getItemName={(item) => item.title}
                  getItemValue={(item) => item.id}
                  items={this.state.values.subtopics}
                  checkedItem={state.values.subtopic}
                  isCheckedValue={(item) => item.id === state.values.subtopic}
                />
              </div>
            </div>
          </fieldset>

          {state.loadingAnswer && (
            <section>
              <div className="answer-preloader">
                <span class="spinner"></span>
              </div>
            </section>
          )}

          {this.state.answers.length > 0 && (
            <Fragment>
              <AutoAnswer answers={this.state.answers} />
              <div>
                <div>
                  <strong>Не нашли ответа в справочнике?</strong>
                  <br />
                  <br />
                  Рекомендуем для более оперативного решения Вашего вопроса
                  направить обращение в чате мобильного приложения «Платосфера»
                  (ссылка для скачивания на мобильное устройство{" "}
                  <a target="_blank" href="//платосфера.рф">
                    https://платосфера.рф
                  </a>
                  )
                </div>
                <div style={{ textAlign: "right" }}>
                  <button className="button-3" onClick={this.closeAutoAnswer}>
                    Задать вопрос в личном кабинете
                    <br />
                    срок ответа до 30 календарных дней
                  </button>
                </div>
              </div>
            </Fragment>
          )}
        </div>

        {/* Основное тело обращения */}
        {state.showForm && (
          <div className="form-block__section">
            <QualityForm
              subject={this.state.values.subject}
              state={this.state.advFields}
              setAdvFields={this.initAdvFields}
              changeInput={this.onChangeAdvField}
              errors={errorsAdvFields}
              address={this.getAddress(this.state.values.contractGlobalId)}
            />

            <div
              className={`form-field form-field_dir-min-md_row form-block__item form-block__item_mgt_xs ${
                errors.message ? "form-field_state_error" : ""
              }`}
            >
              <div className="form-field__inner">
                <div className="form-field__title-row">
                  <label className="form-field__title" htmlFor="message">
                    Вопрос *
                  </label>
                </div>
                <div className="form-field__input-row form-field__input-row_min-ht_none">
                  <textarea
                    className="input input_textarea form-field__input false"
                    id="message"
                    placeholder="Ваш вопрос"
                    value={state.values.message}
                    onChange={this.onChangeInput("message")}
                  />
                </div>
              </div>
            </div>
            <div
              className={`form-field form-field_dir-min-md_row form-block__item form-block__item_mgt_xs ${
                errors.phone ? "form-field_state_error" : ""
              }`}
            >
              <div className="form-field__inner">
                <div className="form-field__title-row">
                  <label className="form-field__title" htmlFor="phone">
                    Мобильный телефон
                  </label>
                </div>
                <div className="form-field__input-row">
                  <input
                    className="input form-field__input false"
                    type="text"
                    id="phone"
                    placeholder="+ 7 (000) 000 00 00"
                    ref={this.phoneInputRef}
                  />
                </div>
              </div>
            </div>
            <div
              className={`form-field form-field_dir-min-md_row form-block__item form-block__item_mgt_xs ${
                errors.email ? "form-field_state_error" : ""
              }`}
            >
              <div className="form-field__inner">
                <div className="form-field__title-row">
                  <label className="form-field__title" htmlFor="email">
                    Email
                  </label>
                </div>
                <div className="form-field__input-row">
                  <input
                    className="input form-field__input false"
                    id="email"
                    placeholder=""
                    value={state.values.email}
                    onChange={this.onChangeInput("email")}
                  />
                </div>
              </div>
            </div>
            <div
              className={`form-field form-field_dir-min-md_row form-block__item form-block__item_mgt_xs ${
                errors.name ? "form-field_state_error" : ""
              }`}
            >
              <div className="form-field__inner">
                <div className="form-field__title-row">
                  <label className="form-field__title" htmlFor="subject">
                    Как к Вам обращаться?
                  </label>
                </div>
                <div className="form-field__input-row">
                  <input
                    className="input form-field__input false"
                    id="subject"
                    placeholder=""
                    value={state.values.name}
                    onChange={this.onChangeInput("name")}
                  />
                </div>
              </div>
            </div>
            {props.isTerminal ? (
              <CameraButton
                openModal={this.openModal}
                onDeleteFile={(file, field) => this.onDeleteFile(file)}
                field={"files"}
                values={this.state.values}
                errors={errors}
                getLabelField={() => "Прикрепить файл"}
              />
            ) : (
              <FileInput
                onChangeFile={(field) => this.onChangeFile}
                onDeleteFile={(file, field) => this.onDeleteFile(file)}
                field={"files"}
                values={this.state.values}
                errors={errors}
                getLabelField={() => "Прикрепить файл"}
              />
            )}
          </div>
        )}

        {this.state.showForm && (
          <div className="form-block__footer">
            {!!errors &&
              Object.values(errors).map((item) => {
                return <p className="form__error-text">{item}</p>;
              })}
            {!!errorsAdvFields &&
              Object.values(errorsAdvFields).map((item) => {
                return <p className="form__error-text">{item}</p>;
              })}
            <button
              onClick={this.onSubmitForm}
              disabled={
                Object.keys(errors).length ||
                Object.keys(errorsAdvFields).length
              }
              className="button-primary button-primary_bgc_brand-2 form-block__footer-item form-block__footer-item_wd_md"
            >
              {this.state.loading ? "Отправка" : "Отправить"}
            </button>
          </div>
        )}
        {props.isTerminal && state.modalCamera && (
          <Modal
            onClose={this.closeModal}
            onChange={this.onChangeCameraInput}
          />
        )}
      </form>
    );
  }

  getAddress = (contractGlobalId) => {
    const data = this.props.contracts.filter((e) => {
      return e.contractGlobalId == contractGlobalId;
    });
    if (data.length == 0) return "";
    return data[0].address;
  };

  initAdvFields = (list) => {
    if (Object.keys(this.state.advFields).length === 0) {
      console.log(list);
      this.setState({
        advFields: list.values,
        advFieldsRequired: list.requireds,
        advFieldsNames: list.names,
      });
    }
  };

  onChangeAdvField = (field, value) => (e) => {
    let values = { [field]: value == undefined ? e.target.value : value };
    this.setState({
      advFields: {
        ...this.state.advFields,
        ...values,
      },
    });
  };

  closeModal = () => {
    this.setState({ modalCamera: false });
  };

  openModal = () => {
    this.setState({ modalCamera: true });
  };

  isRequired = (fieldName) =>
    this.requiredFields.indexOf(fieldName) !== -1 ? "* " : "";

  validate = () => {
    let errors = {};
    if (!this.submitted) return errors;

    const self = this;
    const { values } = this.state;

    this.requiredFields.forEach((requiredField) => {
      if (
        typeof values[requiredField] === "undefined" ||
        values[requiredField] === null ||
        values[requiredField].length === 0
      ) {
        if (
          !(
            requiredField === "subtopic" &&
            self.state.values.subtopics.length === 0
          )
        ) {
          const fieldName =
            requiredField in self.fieldsName
              ? self.fieldsName[requiredField]
              : "";
          errors[requiredField] = `"${fieldName}" обязательно для заполнения`;
        }
      }
    });

    if (values.email && !validateEmail(values.email)) {
      errors.email = "E-mail заполнен неверно";
    }

    if (values.message.length >= 1500) {
      errors.message = '"Вопрос" не должен превышать 1500 символов';
    }

    errors = {
      ...errors,
      ...validateFiles(
        values.files,
        maxCountFile,
        maxSizeFile,
        allowedFileTypes
      ),
    };

    return errors;
  };

  validateAdvFields = () => {
    let errors = {};

    if (!this.submitted) return errors;
    if (Object.keys(this.state.advFields).length === 0) return errors;

    const values = this.state.advFields;
    const requiredFields = this.state.advFieldsRequired;
    const fieldsNames = this.state.advFieldsNames;

    requiredFields.forEach((requiredField) => {
      if (
        typeof values[requiredField] === "undefined" ||
        values[requiredField] === null ||
        values[requiredField].length === 0
      ) {
        const fieldName =
          requiredField in fieldsNames ? fieldsNames[requiredField] : "";
        errors[requiredField] = `"${fieldName}" обязательно для заполнения`;
      }
    });

    return errors;
  };

  onChangeInput = (field) => (e) => {
    this.setValues({ [field]: e.target.value });
  };

  _xor = (a, b) => (a || b) && !(a && b);

  onChangeAddress = (e) => {
    let contractId = null;
    // this hack is needed becase SelectInput return value 'on' when value passed as null
    // may be fix it later
    for (let i = 0; i < this.props.contracts.length; ++i) {
      if (this.props.contracts[i].contractGlobalId === e.target.value) {
        contractId = this.props.contracts[i].contractGlobalId;
      }
    }
    let subjects = contractId ? this.props.subjects : this.props.subjectsCut;
    let newValues = {
      contractGlobalId: contractId,
    };
    if (this._xor(this.state.values.contractGlobalId, contractId)) {
      newValues = {
        ...newValues,
        subject: undefined,
        subjects: subjects,
        subtopic: undefined,
      };
    }
    this.setValues(newValues);
  };

  onChangeSubject = (e) => {
    let subtopics = this.state.values.subjects.find(function (item, index) {
      return item.id === e.target.value;
    });

    this.setValues({
      subject: e.target.value,
      subtopic: undefined,
      subtopics: typeof subtopics !== "undefined" ? subtopics.subtopics : [],
    });
    this.setState({
      answers: [],
      showForm: false,
      advFields: {},
      advFieldsNames: {},
    });
  };

  onChangeSubtopic = (e) => {
    this.setValues({ subtopic: e.target.value });
    this.setState({
      answers: [],
      showForm: false,
      loadingAnswer: true,
      advFields: {},
      advFieldsNames: {},
    });
    this.fetchAutoAnswer(e.target.value);
  };

  fetchAutoAnswer = (id) => {
    const url = this.props.url_auto_answer + "?id=" + id;
    const self = this;

    sendRequest(url, {
      type: "GET",
      headers: { contentType: false, processData: false },
      showLoader: false,
    }).then((data) => {
      self.setState({
        answers: data.data,
        loadingAnswer: false,
        showForm: data.data.length > 0 ? false : true,
      });
    });
  };

  closeAutoAnswer = () => {
    this.setState({ answers: [], showForm: true });
  };

  onChangeFile = (e) => {
    this.setValues({ files: [...this.state.values.files, ...e.target.files] });
  };

  onChangeCameraInput = (file, fileDataUrl) => {
    this.setValues({ files: [...this.state.values.files, file] });
  };

  onDeleteFile = (file) => (e) => {
    e.preventDefault();
    this.setValues({
      files: [...this.state.values.files.filter((item) => item !== file)],
    });
  };

  setValues = (values) => {
    this.setState({
      values: {
        ...this.state.values,
        ...values,
      },
    });
  };

  onSubmitForm = (e) => {
    e.preventDefault();
    const self = this;
    this.submitted = true;

    const errors = this.validate();
    const errorsAdvFields = this.validateAdvFields();
    if (Object.keys(errors).length || Object.keys(errorsAdvFields).length) {
      this.forceUpdate();
      return;
    }

    let prop_subject = this.state.values.subjects.find(function (item, index) {
      return item.id === self.state.values.subject;
    });
    let prop_subtopic = prop_subject.subtopics.find(function (item, index) {
      return item.id === self.state.values.subtopic;
    });

    let message = "";
    let adv_keys = Object.keys(this.state.advFieldsNames);
    if (adv_keys.length == 0) {
      message = this.state.values.message;
    } else {
      adv_keys.forEach((key) => {
        message +=
          this.state.advFieldsNames[key] +
          ": " +
          this.state.advFields[key] +
          "\n";
      });
      message += "Сообщение: " + this.state.values.message;
    }

    const formData = new FormData();
    const { values } = this.state;
    const values_phone = values.phone.replace(/[^\d]/g, "");
    formData.append("contractId", values.contractGlobalId);
    let subject = prop_subtopic.title
      ? prop_subject.title + ": " + prop_subtopic.title
      : prop_subject.title;
    formData.append("subject", subject);
    formData.append("message", message);
    formData.append("phone", values_phone);
    formData.append("email", values.email);
    formData.append("name", values.name);
    formData.append(
      "serviceId",
      prop_subtopic.serviceId === null ? "" : prop_subtopic.serviceId
    );
    formData.append("NesTopicId", values.subject);
    formData.append("NesSubTopicId", values.subtopic);
    if (values.files.length) {
      values.files.forEach((item) => {
        formData.append("files[]", item);
      });
    }

    sendRequest(this.props.url, {
      body: formData,
      type: "POST",
      headers: { contentType: false, processData: false },
      showLoader: true,
    }).then((data) => {
      self.setState({ loading: false });
      if (data.status !== 200) {
        $.disMsg(
          "Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.",
          { type: "false" }
        );
        return;
      }

      if (!data.data.number) {
        $.disMsg(
          "Произошла неизвестная ошибка во время выполнения запроса.</br> Пожалуйста, обратитесь в техподдержку.",
          { type: "false" }
        );
        return;
      }

      this.clearForm();
      if (typeof this.props.onSubmited === "function") {
        const number =
          "<a href='" +
          this.props.urlToDetail +
          data.data.number +
          "' target='_blank'>" +
          data.data.number +
          "</a></b>";

        this.props.onSubmited(number);
      }
    });
  };
}
